var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main_content", attrs: { id: "mainContent" } }, [
      _c("div", { staticClass: "preview", attrs: { id: "editor-preview" } }, [
        _c("div", { staticClass: "question_title" }, [
          _c("span", { staticClass: "title" }, [
            _vm._v("\n          " + _vm._s(_vm.questionTitle) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { float: "right", display: "flex" } }, [
            _c("div", {
              staticStyle: { display: "none" },
              attrs: { id: "example-timer" },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "percent-title",
              staticStyle: { "margin-right": "20px", display: "none" },
              attrs: { id: "time-left" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "percent-title" }, [
              _vm._v("\n            回答率\n          "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status" }, [
              _c("div", {
                staticClass: "status-percent",
                style: { width: _vm.answeredRate.toFixed(2) + "%" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "percent" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.answeredRate.toFixed(2)) +
                  " %\n          "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        !_vm.isSubmitPage
          ? _c(
              "div",
              [
                _vm._l(_vm.currentQuestions, function (currentQuestion) {
                  return _c(
                    "div",
                    {
                      key: currentQuestion.id,
                      staticClass: "question-body-preview",
                    },
                    [
                      _c("QuestionContent", {
                        ref: "question_content",
                        refInFor: true,
                        attrs: {
                          currentQuestion: currentQuestion,
                          currentQuestionIndex: _vm.currentQuestionIndex,
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.currentQuestionIndex > -1
                  ? _c("div", [
                      !_vm.blankQuestion
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary next-answer",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.answerQuestion()
                                },
                              },
                            },
                            [_vm._v("回答する")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-primary next-answer",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.nextQuestion()
                                },
                              },
                            },
                            [_vm._v("次へ")]
                          ),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _c("div", [
              _vm.answeredTotal == _vm.questionTotal
                ? _c(
                    "div",
                    {
                      staticClass: "test_info",
                      staticStyle: { "padding-top": "20px" },
                    },
                    [_vm._v("\n          未回答の問題がありません\n        ")]
                  )
                : _c("div", { staticClass: "test_info" }, [
                    _c("div", [
                      _vm._v(
                        "未回の答問題が" +
                          _vm._s(_vm.questionTotal - _vm.answeredTotal) +
                          "問あります"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("回答率\n            "),
                      _c("span", { staticClass: "test_left" }, [
                        _vm._v(_vm._s(_vm.answeredRate.toFixed(2)) + " %"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.timer != 0
                      ? _c(
                          "div",
                          [
                            _c("h3", [_vm._v("未回答の問題")]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.groupQuestions,
                              function (question_group, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "test-left-list" },
                                  [
                                    !_vm.isAnsweredGroup(
                                      question_group.questions
                                    ) &&
                                    !_vm.isBlankGroupQuestion(
                                      question_group.questions
                                    )
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.changeQuestion({
                                                    index: parseInt(index),
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  問題 " +
                                                  _vm._s(
                                                    question_group.question_index
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "\n            回答時間が切りました。\n          "
                          ),
                        ]),
                  ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "submit-btn btn-lg btn-warning btn btn-primary next-answer",
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("テストを提出する")]
              ),
            ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "a",
        {
          staticClass: "btn btn-default back",
          attrs: { disabled: _vm.currentQuestionIndex <= 0 },
          on: { click: _vm.prevQuestion },
        },
        [_vm._v("< 前の問題")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary next-answer next",
          attrs: { disabled: _vm.isSubmitPage },
          on: { click: _vm.nextQuestionEvent },
        },
        [_vm._v("次の問題 >")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }